<template>
  <teleport to="body" v-if="visible">
    <div class="img-global-mask" @click.stop="close">
      <a class="img-global-close hitems-close" @click="close"></a>
      <img class="img-global-image" :src="props.src || ''" />
    </div>
  </teleport>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  defineOptions({
    name: 'AppFullScreenImage'
  })
  const props = defineProps<{
    src: string
    visible: boolean
  }>()
  const emit = defineEmits(['close'])
  const close = () => {
    emit('close')
  }
</script>

<style scoped>
  .img-global-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background:
      linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    box-shadow: 0px 0px 52px 0px rgba(0, 0, 0, 0.25);
    z-index: 110;
  }

  .img-global-mask :deep(.loaded-img) {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    object-fit: contain;
  }

  .img-global-close {
    position: absolute;
    top: 4rem;
    right: 4rem;
    width: 4rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aaa;
    background-color: #fff;
    border-radius: 50%;
    font-size: 2rem;
    z-index: 2;
  }

  .img-global-close:hover {
    color: #666;
  }
  .img-global-image {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    object-fit: contain;
  }
</style>
